import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'badgeVehicle',
  standalone: true,
})
export class BadgeVehiclePipe implements PipeTransform {
  private readonly statusColorMap: { [key: string]: string } = {
    new: 'text-new',
    used: 'text-used',
    units: 'text-campaign',
    renting: 'text-renting',
    leasing: 'text-leasing',
  };

  transform(status: string): string {
    return this.statusColorMap[status] || 'text-new';
  }
}
